import { Component, OnInit ,ElementRef ,ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { BrdsqlService } from '../../../services/brdsql.service';
import { AppServiceService } from '../../../services/app-service.service';
import * as XLSX from 'xlsx'; 
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-emp-faction',
  templateUrl: './emp-faction.component.html',
  styleUrls: ['./emp-faction.component.css']
})
export class EmpFactionComponent implements OnInit {

  factionData?:any = [];
  facEdit?:any = [];
  partData?:any = [];
  partEdit?:any = [];
  @ViewChild('tb_faction') tb_faction!: ElementRef;
  @ViewChild('tb_part') tb_part!: ElementRef;
  @ViewChild('frm_addFac') frm_addFac!: NgForm;
  @ViewChild('frm_addPart') frm_addPart!: NgForm;
  formFacEdit = false;
  formPartEdit = false;
  factionEdit?:any = [];
  fileName= 'ExcelDownload.xlsx'; 

  constructor(
    private brdservice: BrdsqlService,
    private appservice: AppServiceService,
  ) { }

  ngOnInit(): void {
    this.factionList()
    this.partList()
  }

  async factionList() {
    this.factionData = [];
    await this.brdservice.factionList()
    .subscribe({
      next: (data:any) => {
        this.factionData = data.recordset;
        setTimeout(() => {
          $(this.tb_faction.nativeElement).DataTable();
        }, 0);
      }
    })
  }

  async partList() {
    this.partData = null;
    await this.brdservice.partList()
    .subscribe({
      next: (data:any) => {
        this.partData = data.recordset;
        // this.partData = this.partData.sort((a,b) => a.partcode.rendered.localeCompare(b.partcode.rendered));
        this.partData = this.partData.sort((a,b)=>a.partcode.rendered > b.partcode.rendered)
        // console.log('partData ' ,this.partData);
        setTimeout(() => {
          $(this.tb_part.nativeElement).DataTable();
        }, 0);
      }
    })
  }

  editFac(dataid:string) {
    this.formFacEdit = true;  // สถานะเป็นฟอร์มแก้ไข
    this.facEdit = this.factionData.filter((el: { dataid: any; }) => el.dataid == dataid);
    this.facEdit = this.facEdit[0];
    // console.log('depEdit ' ,this.depEdit);
  }

  editPart(dataid:string) {
    this.formPartEdit = true;  // สถานะเป็นฟอร์มแก้ไข
    this.partEdit = this.partData.filter((el: { dataid: any; }) => el.dataid == dataid);
    this.partEdit = this.partEdit[0];
    // console.log('depEdit ' ,this.depEdit);
  }

  // บันทึกฟอร์มเพิ่มข้อมูลฝ่าย
  saveAddFaction(f: any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      // text: 'You will not be able to recover this file!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.saveAddFaction(f)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.factionList();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
    })
  };

  // บันทึกการแก้ไขข้อมูลฝ่าย
  saveEditFac(f: any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      // text: 'You will not be able to recover this file!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.updateFaction(f)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.factionList();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
    })
  };

  // บันทึกฟอร์มเพิ่มข้อมูลส่วน
  saveAddPart(f: any) {
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      // text: 'You will not be able to recover this file!',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.saveAddPart(f)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.factionList();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
    })
  };

// บันทึกการแก้ไขข้อมูลฝ่าย
saveEditPart(f: any) {
  Swal.fire({
    title: 'ยืนยันการบันทึกข้อมูล?',
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'OK ตกลง',
    cancelButtonText: 'ยกเลิก'
  }).then((result) => {
    if (result.value) {
      this.brdservice.updatePart(f)
        .subscribe({
          next: (data: any) => {
            console.log('response:', data);
            if (data.rowsAffected == 1) {
              Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
              this.partList();
              this.formPartReset();
            } else {
              Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
            }
          }
        });
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire(
        'ยกเลิกการบันทึกข้อมูล',
        'cancle'
      )
    }
  })
};  

// ลบข้อมูลฝ่าย
  delFaction(dataid:any) {
    Swal.fire({
      title: 'ยืนยันการลบข้อมูล?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        this.brdservice.delFaction(dataid)
          .subscribe({
            next: (data: any) => {
              console.log('response:', data);
              if (data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
                this.factionList();
                this.formFacReset();
              } else {
                Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
              }
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          'cancle'
        )
      }
    })
  }

// ลบข้อมูลส่วน
delPart(f:any) {
  console.log('dataid: ' ,f.dataid)
  Swal.fire({
    title: 'ยืนยันการลบข้อมูล?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'OK ตกลง',
    cancelButtonText: 'ยกเลิก'
  }).then((result) => {
    if (result.value) {
      this.brdservice.delPart(f.dataid)
        .subscribe({
          next: (data: any) => {
            console.log('response:', data);
            if (data.rowsAffected == 1) {
              Swal.fire('บันทึกข้อมูลสำเร็จ!', 'success')
              this.partList();
              this.formPartReset();
            } else {
              Swal.fire({ icon: 'error', title: 'Oops...', text: 'บันทึกข้อมูลไม่สำเร็จ!', footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>' })
            }
          }
        });
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire(
        'ยกเลิกการบันทึกข้อมูล',
        'cancle'
      )
    }
  })
}  

numberOnly(event:any) {
    this.appservice.numberOnly(event)
}

exportExcel(): void {
    {
      /* table id is passed over here */
      let element = document.getElementById('position-table');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      /* save to file */
      XLSX.writeFile(wb, this.fileName);

    }
}  

formFacReset() {
    this.frm_addFac.reset()
    this.formFacEdit = false;
}

  formPartReset() {
    this.frm_addPart.reset()
    this.formPartEdit = false;
  }

}
